import '../../resources/css/layout/FormLayout.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { WAIT_LOGIN, reLoginBySession } from '../../actions/login/index';
import Loading from '../../components/common/Loading';
import HoodDeviceForm from '../../components/dashboard/HoodDeviceForm';
import ModelForm from '../../components/maintenance/ModelForm';
import ResetPasswordPage from '../../components/login/ResetPasswordPage';

class FormLayout extends Component {  

  constructor(props) {
    super(props);

    // bind this props to function
    this.goBack = this.goBack.bind(this);
  };

  isNeedReLogin = ( loginStatus ) => {
    if (loginStatus === WAIT_LOGIN) {
      const loginParams = window.sessionStorage.getItem('RangeHood.LoginParams');
      if (loginParams) {
        return true;
      }
    }
    return false;
  }

  goBack = () => {
    const {callback} = this.props;
    if (callback && callback.closeCallback) {
      callback.closeCallback();
    }
    this.props.history.goBack();
  }

  componentDidMount() {
    const { loginStatus, reLoginBySession } = this.props;

    if (this.isNeedReLogin(loginStatus)) {
      reLoginBySession();
    }
    
  }

  render() {
    const { loginStatus, modalStatus, modalRedirect } = this.props;
    
    // do auto re-login by session
    if (this.isNeedReLogin(loginStatus)) {
      return (
        <Loading loading={true}></Loading>
      )
    }

    if (modalRedirect && modalStatus === false) {
      return (        
        <Redirect to={{
          pathname: modalRedirect
        }}/>
      )
    }

    return (
      <div className="form-layout-body">   
          <div className="close-button" onClick={this.goBack}><span className="icon-close"></span></div>
          <Switch>
            <Route path="/HoodList/:formType" exact component={HoodDeviceForm} />
            <Route path="/HoodModeList/:formType" exact component={ModelForm} />
            <Route path="/Main/ResetPassword" exact component={ResetPasswordPage} />
          </Switch>
          {/* <ModalFrame modalStatus={modalStatus} modalMessage={modalMessage} modalRedirect={modalRedirect}/>  */}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modalStatus:  state.commonReducers.modalStatus,
    modalMessage: state.commonReducers.modalMessage,
    modalRedirect: state.commonReducers.modalRedirect,
    callback: state.commonReducers.callback,
    loginStatus: state.logindReducers.status
  }
}

export default withRouter(connect(
  mapStateToProps,
  { reLoginBySession }
)(FormLayout))